import PropTypes from 'prop-types';
import { StepperInput } from 'foundations-components/transitional/components/StepperInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { InputGroup } from 'foundations-components/transitional/components/InputGroup';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { LinkIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const castAsNumber = value => value || value === 0 ? +value : undefined;
const Dimensions = props => /*#__PURE__*/_jsxs(InputGroup, {
  alignItems: "center",
  gap: true,
  marginBlockStart: "300",
  use: "none",
  children: [/*#__PURE__*/_jsx(FormControl, {
    label: props.widthLabel,
    margin: "0",
    children: /*#__PURE__*/_jsx(StepperInput, {
      "data-selenium": props.widthSeleniumKey,
      max: props.maxWidth,
      min: 0,
      onChange: props.onWidthChange,
      readOnly: props.readOnly,
      stepSize: 1,
      use: props.useOnDark ? 'on-dark' : 'default',
      value: castAsNumber(props.width)
    })
  }), /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    flexGrow: 0,
    flexBasis: "auto",
    children: /*#__PURE__*/_jsx(IconHolder, {
      color: props.useOnDark ? 'icon-tertiary-disabled' : 'fill-tertiary-pressed',
      icon: LinkIcon,
      marginInline: "200",
      paddingBlockStart: "900",
      padding: "0",
      size: "200"
    })
  }), /*#__PURE__*/_jsx(FormControl, {
    label: props.heightLabel,
    margin: "0",
    children: /*#__PURE__*/_jsx(StepperInput, {
      "data-selenium": props.heightSeleniumKey,
      max: props.maxHeight,
      min: 0,
      onChange: props.onHeightChange,
      readOnly: props.readOnly,
      stepSize: 1,
      use: props.useOnDark ? 'on-dark' : 'default',
      value: castAsNumber(props.height)
    })
  })]
});
Dimensions.propTypes = {
  height: PropTypes.node,
  heightLabel: PropTypes.node.isRequired,
  heightSeleniumKey: PropTypes.string,
  maxHeight: PropTypes.number,
  maxWidth: PropTypes.number,
  onHeightChange: PropTypes.func.isRequired,
  onWidthChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  useOnDark: PropTypes.bool,
  width: PropTypes.node,
  widthLabel: PropTypes.node.isRequired,
  widthSeleniumKey: PropTypes.string
};
export default Dimensions;